import { supabase } from "../supabase/SupabaseClient";

/* Registro de Salida Pendiente (ticket 417): lo que tiene que sobrevivir a
 * recargar la página — «Omitir» de hoy y las alertas desatendidas de la
 * campana. Cada uno ve y escribe sólo las suyas (RLS por `mi_mail()`, migración
 * 20261016012320). Los avisos de cada 5 minutos no se guardan: se calculan. */

const TABLA = "porteria_salida_alertas";
export const DIAS_CAMPANA = 30;

/* 23505 = ya había una fila para esa persona y ese día: no es un error, es que
 * otra pestaña (u otra máquina) llegó primero. */
const yaEstaba = (error) => error?.code === "23505";

/* Las alertas de los últimos días, de la más nueva a la más vieja. */
export async function misAlertasSalida(usuario, dias = DIAS_CAMPANA) {
  const desde = new Date(Date.now() - dias * 24 * 3600 * 1000).toISOString().slice(0, 10);
  const { data, error } = await supabase
    .from(TABLA)
    .select("id, dia, estado, pendientes, creado_en, visto_en")
    .eq("usuario", String(usuario || "").toLowerCase())
    .gte("dia", desde)
    .order("dia", { ascending: false });
  if (error) throw error;
  return data || [];
}

async function anotar(usuario, dia, estado, pendientes = []) {
  const { error } = await supabase.from(TABLA).insert({
    usuario: String(usuario || "").toLowerCase(),
    dia,
    estado,
    pendientes: (pendientes || []).map(({ patente, nombre }) => ({ patente, nombre })),
  });
  if (error && !yaEstaba(error)) throw error;
}

/* «Omitir»: hoy no se le vuelve a mostrar. */
export const omitirSalidaDeHoy = (usuario, dia) => anotar(usuario, dia, "omitida");

/* Se agotó el tiempo con salidas sin registrar: queda en la campana. */
export const anotarDesatendida = (usuario, dia, pendientes) =>
  anotar(usuario, dia, "desatendida", pendientes);

/* «Entendido» en la lista de la campana: apaga el asterisco de ésa. */
export async function marcarAlertaVista(id) {
  const { error } = await supabase
    .from(TABLA)
    .update({ visto_en: new Date().toISOString() })
    .eq("id", id)
    .is("visto_en", null);
  if (error) throw error;
}
